import React from 'react'
import img from '../Img/img.png'
import twitter from '../Img/Twitter.png'
import linkdin from '../Img/Linkdin.png'
import link from '../Img/link.png'
import qrcode from '../Img/QRcode.png'
import { Link } from 'react-router-dom'

function Profile() {
  return (
    <div>
        <div className='m-4 mt-12 flex justify-center'>
        <h1 className='font-bold text-lg'>Hey Your profile NFT</h1>
      </div>
      <div className='flex flex-col justify-evenly rounded-lg py-14 items-center mt-[50px] mx-[24px] w-[325px] h-[382px] bg-[#D3F36B]'>
        <div className='h-[194px] flex flex-col  items-center'>
            <img className='w-[60px]' src={img} alt="" />
            <h3 className='font-bold mt-4 text-lg'>Chaal Pritam</h3>
            <p className='text-sm mt-4 text-gray-700 w-52 text-center'>I’m available to connect live, here iam a web3 designer ahead.</p>
        </div>
        <div className='flex justify-evenly'>
            <div className='mt-10 space-y-5'>
            <div className='flex space-x-2'>
                <img className='w-[18px] h-[18px] mt-1' src={twitter} alt="" />
                <p>@iam_Chaalpritam</p>
            </div>
            <div className='flex space-x-2'>
                <img className='w-[18px] h-[18px] mt-1' src={linkdin} alt="" />
                <p>@iamChaalpritam</p>
            </div>
            
            </div>
            <img className='mt-5 ml-5' src={qrcode} alt="" />
        </div>
      </div>
      <Link to='/createevent' className='px-20 mx-10 absolute  py-3 mt-20 bg-black font-semibold text-white rounded-3xl'>Mint Profile NFT</Link>
    </div>
  )
}

export default Profile